var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/TextLink';
import styles from '../../components/VerticalTextLinks/index.module.scss';
const VerticalTextLinks = ({ links, maxLength }) => {
    if (!(links === null || links === void 0 ? void 0 : links.length)) {
        return null;
    }
    let linkList = links;
    if (maxLength && linkList.length > maxLength) {
        linkList = linkList.slice(0, maxLength);
    }
    return (React.createElement("div", { className: `${styles.container} vertical-text-links`, "data-testid": "vertical-text-links" }, linkList.map((_a) => {
        var { label } = _a, props = __rest(_a, ["label"]);
        return (React.createElement(TextLink, Object.assign({}, props, { className: styles.link, key: label }), label));
    })));
};
export default VerticalTextLinks;
//# sourceMappingURL=index.js.map